<template lang="pug">
  main.view-y(role="main").theme-background
    router-view
</template>

<script>
export default {
  components: {},
  mounted: function() {}
};
</script>


<style lang="scss" scoped>
// main {
//   background: rgb(128, 208, 199);
//   background: -moz-radial-gradient(center, ellipse cover, rgba(128, 208, 199, 1) 0%, rgba(19, 84, 122, 1) 100%);
//   background: -webkit-radial-gradient(center, ellipse cover, rgba(128, 208, 199, 1) 0%, rgba(19, 84, 122, 1) 100%);
//   background: radial-gradient(ellipse at center, rgba(128, 208, 199, 1) 0%, rgba(19, 84, 122, 1) 100%);
//   filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#80d0c7', endColorstr='#13547a',GradientType=1 );

//   background: rgb(253, 252, 251);
//   background: -moz-radial-gradient(center, ellipse cover, rgba(253, 252, 251, 1) 0%, rgba(226, 209, 195, 1) 100%);
//   background: -webkit-radial-gradient(center, ellipse cover, rgba(253, 252, 251, 1) 0%, rgba(226, 209, 195, 1) 100%);
//   background: radial-gradient(ellipse at center, rgba(253, 252, 251, 1) 0%, rgba(226, 209, 195, 1) 100%);

//   background: #5b4e63;
//   background: -moz-radial-gradient(center, ellipse cover, #5b4e63 0%, #322c36 100%);
//   background: -webkit-radial-gradient(center, ellipse cover, #5b4e63 0%, #322c36 100%);
//   background: radial-gradient(ellipse at center, #5b4e63 0%, #322c36 100%);
//   @extend .g-theme1;
// }
</style>
